$(function() {
    $('#birth-date, #death-date').on('keypress input', function(e) {
        const keyCode = e.which;

        // Allow numbers, backspace, and delete
        if (!((keyCode >= 48 && keyCode <= 57) || keyCode === 8 || keyCode === 46)) {
            e.preventDefault();
        }
    });

    if ($('.page-template-template-map').length === 0) {
        return;
    }

    function delaySearchResults(fn, ms) {
        let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(fn.bind(this, ...args), ms || 0);
        };
    }

    function getSearchResults() {
        const formData = grabFormAsObject($('.js-search-form'));

        if (!Cookies.get('operator_token')) {
            const excludeFromFormData = [
                'funeralTimeFrom',
                'funeralTimeTo',
                'graveValidUntilFrom',
                'graveValidUntilTo',
            ];
            excludeFromFormData.forEach(prop => delete formData[prop]);
        }

        $.ajax({
            url: `${window.api}/search`,
            type: 'GET',
            data: formData,
            headers: {
                Authorization: 'Bearer ' + window.iFrameToken,
            },
            success: function(response) {
                if (!response.length) {
                    const output = `<div class="search-bar-results-block">
                        <div class="search-bar-result js-zoom-to" style="pointer-events:none;">
                            <div>
                                <p class="search-bar-graveyard js-find-name">Nincs ilyen találat</p>
                            </div>
                        </div>
                    </div>`;

                    return $('.js-result-wrapper').html(output);
                }

                const res = response.slice(0, 50);
                const searchResults = [];

                for (let i = 0; i < res.length; i++) {
                    let value = res[i];

                    searchResults.push({
                        name: value.name,
                        birthDate: value.birthDate ? value.birthDate.split('-')[0] : 'n.a.',
                        deathDate: value.deathDate ? value.deathDate.split('-')[0] : 'n.a.',
                        funeralTime: value.funeralTime
                            ? `Temetés dátuma: ${formatDate(value.funeralTime)}`
                            : '',
                        graveValidUntil: value.graveValidUntil
                            ? `Sírhely lejár: ${formatDate(value.graveValidUntil)}`
                            : '',
                        graveId: value.graveId,
                        id: value.id,
                    });
                }

                const output = searchResults.map(result => {
                    return `<div class="search-bar-results-block">
                        <div class="search-bar-result js-zoom-to" data-graveid="${result.graveId}" data-id="${result.id}">
                            <img src="assets/img/cross.svg" alt="">
                            <div>
                                <p class="search-bar-graveyard js-find-name">${result.name}</p>
                                <p class="time js-find-date">${result.birthDate} - ${result.deathDate}</p>
                                <p class="js-funeral-time funeral-time">${result.funeralTime}</p>
                                <p class="js-grave-valid funeral-time">${result.graveValidUntil}</p>
                            </div>
                        </div>
                    </div>`;
                });

                $('.search-bar-count').text(output.length);
                $('.js-result-wrapper').html(output);
            },
        });
        return;
    }

    $('.search-block input[type="text"], .search-dates input[type="number"]').on(
        'input',
        delaySearchResults(function() {
            if ($(this).val().length < 3) {
                const output = `<div class="search-bar-results-block">
                        <div class="search-bar-result js-zoom-to" style="pointer-events:none;">
                            <div>
                                <p class="search-bar-graveyard js-find-name">Kérjük legalább 3 karaktert adjon meg a kereséshez!</p>
                            </div>
                        </div>
                    </div>`;
                return $('.js-result-wrapper').html(output);
            }
            getSearchResults();
        }, 500)
    );

    $('.select--graveyard').on(
        'change',
        delaySearchResults(function() {
            if (
                $('.search-block input[type="text"]').val() != '' ||
                $('.search-dates input[type="number"]').val() != ''
            ) {
                getSearchResults();
            }
        }, 500)
    );

    $('#graveValidStart, #graveValidEnd, #funeralTimeStart, #funeralTimeEnd').on(
        'input change',
        delaySearchResults(function(e) {
            e.preventDefault();
            getSearchResults();

            const filteredGraves = getSearchResults();

            window.widget.selectElement(
                filteredGraves,
                'filteredGraves',
                'graveYardsLayer',
                'graveyardId',
                {
                    borderColor: 'red',
                    fillColor: 'red',
                }
            );
        }, 500)
    );
});
